<span class="badge badge-primary rounded-pill" [ngClass]="[size, type]">{{ title$ | async }}</span>
